// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"cdc85298","452":"7f06e3f6","455":"c8cb21ee","747":"e2831f4d"}[chunkId] + ".chunk.js";
};